import { Box, styled } from "components/common";

export const ProductDetailsWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  margin: "auto",
  "& .product-details-main": {
    padding: theme.spacing(3),
    // display: "flex",
    // justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
    "& .product-details-row": {
      width: "100%",

      "& .product-details-right-left": {
        paddingRight: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
          order: 2,
          paddingRight: theme.spacing(0),
          paddingBottom: theme.spacing(2),
          paddingTop: theme.spacing(2),
        },
      },
      "& .product-details-right-mid": {
        "& .image-gallery-slides": {
          borderWidth: "3px",
          borderStyle: "solid",
          borderColor: theme.palette.primary.main,
          borderRadius: theme.shape.borderRadius,
        },
        "& .image-gallery-image": {
          maxHeight: "calc(100vh - 220px) !important",
          height: "100%",
          aspectRatio: "1 / 1",
        },
        "& .image-gallery-thumbnail": {
          borderRadius: theme.shape.borderRadius,
          borderStyle: "dashed",
          aspectRatio: "1/1",
        },
        "& .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus": {
          borderStyle: "solid",
          borderColor: theme.palette.primary.main,
          borderRadius: theme.shape.borderRadius,
        },
        "& .image-gallery-thumbnail:hover": {
          borderColor: theme.palette.primary.main,
          borderRadius: theme.shape.borderRadius,
        },
        "& .image-gallery-thumbnail .image-gallery-thumbnail-image": {
          aspectRatio: "1/1",
          objectFit: "contain",
        },
      },
      "& .product-details-right-col": {
        paddingLeft: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
          paddingLeft: theme.spacing(0),
          paddingBottom: theme.spacing(2),
          order: 3,
        },
      },
    },
  },
}));
